import React from 'react';
import cn from 'classnames';
import { ChevronDownMIcon } from '@alfalab/icons-glyph/ChevronDownMIcon';
import { ChevronDownSIcon } from '@alfalab/icons-glyph/ChevronDownSIcon';

var styles = {"arrow":"select__arrow_1jrl7","disabled":"select__disabled_1jrl7","size-40":"select__size-40_1jrl7","open":"select__open_1jrl7"};
require('./index.css');

var Arrow = function (_a) {
    var _b;
    var open = _a.open, disabled = _a.disabled, className = _a.className, size = _a.size;
    var ChevronComponent = size === 40 ? ChevronDownSIcon : ChevronDownMIcon;
    return (React.createElement(ChevronComponent, { className: cn(styles.arrow, styles["size-".concat(size)], className, (_b = {},
            _b[styles.open] = open,
            _b[styles.disabled] = disabled,
            _b)) }));
};

export { Arrow };
